import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";

import logo from "../../assets/images/LogoAlonsoForwarding.png";

const API = "https://vms.hexagons.tech/api";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useContext(UserContext);

  const [form, setForm] = useState({
    username: "",
    password: ""
  });

  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include", // ✅ FIX IMPORTANTE (cookies / sesiones / nginx)
        body: JSON.stringify(form)
      });

      let data;

      try {
        data = await res.json(); // ✅ más directo y seguro
      } catch (err) {
        const text = await res.text();
        console.error("Respuesta no es JSON:", text);
        setError("Error del servidor");
        return;
      }

      if (!res.ok) {
        setError(data?.error || "Error de login");
        return;
      }

      if (!data.token) { // ✅ validación crítica
        setError("Respuesta inválida del servidor");
        return;
      }

      login({
        token: data.token,
        username: form.username,
        role: data.role
      });

      navigate("/");
    } catch (err) {
      console.error(err);
      setError("Error de conexión");
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">

      <div className="bg-primary text-white text-center py-4 shadow-md">
        <h1 className="text-lg md:text-xl font-semibold">
          Sistema de Gestión de Visitas
        </h1>
      </div>

      <div className="flex-1 flex items-center justify-center p-4">

        <div className="w-full max-w-md bg-white p-8 rounded-2xl shadow-xl border-l-4 border-primary">

          <div className="flex justify-center mb-6">
            <img
              src={logo}
              alt="Alonso Forwarding"
              className="h-20 md:h-24 object-contain"
            />
          </div>

          <h2 className="text-2xl font-bold text-primary text-center mb-2">
            Acceso al Sistema
          </h2>

          <p className="text-center text-gray-500 text-sm mb-6">
            Ingrese sus credenciales
          </p>

          {error && (
            <div className="bg-red-100 text-red-700 text-sm p-2 rounded mb-4 text-center">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">

            <input
              type="text"
              placeholder="Usuario"
              className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-accent outline-none"
              value={form.username}
              onChange={(e) =>
                setForm({ ...form, username: e.target.value })
              }
            />

            <input
              type="password"
              placeholder="Contraseña"
              className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-accent outline-none"
              value={form.password}
              onChange={(e) =>
                setForm({ ...form, password: e.target.value })
              }
            />

            <button className="w-full bg-primary hover:bg-accent text-white py-3 rounded-lg font-semibold transition">
              Iniciar sesión
            </button>

          </form>
        </div>
      </div>

      <div className="text-center text-xs text-gray-400 py-3">
        Desarrollado por Hexagons Tech SRL para Alonso Forwarding Costa Rica - Todos los derechos reservados © 2026
      </div>

    </div>
  );
}